import { codigos } from "../../resources/constantes.json";

export function desfomatearPorcentaje(porcentaje) {
  var result = porcentaje.replace("%", "").replace(",", ".");
  return result;
}

export function replaceComas(dato) {
  if (dato) return dato.replace(",", ".");
}

export function sortByKey(array, key1, key2, key3) {
  return array.sort(function(a, b) {
    var value = 0;
    var x, y;
    if (key1) {
      x = Number(a[key1]);
      y = Number(b[key1]);
      value = x < y ? 1 : x > y ? -1 : 0;
    }
    if (key2 && value === 0) {
      x = Number(a[key2]);
      y = Number(b[key2]);
      value = x < y ? 1 : x > y ? -1 : 0;
    }
    if (key3 && value === 0) {
      x = Number(a[key3]);
      y = Number(b[key3]);
      value = x < y ? 1 : x > y ? -1 : 0;
    }
    return value;
  });
}

export function formatearNumero(nStr) {
  if (nStr === undefined) {
    return nStr;
  } else if (nStr.indexOf("%") !== -1) {
    return nStr.replace(".", ",");
  }

  nStr += "";
  var x = nStr.split(".");
  if (x.length <= 1) {
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1.$2");
    }
    return x1 + x2;
  } else {
    return x.join(".");
  }
}

export function toFixedTrunc(value, n) {
  const f = Math.pow(10, n);
  return (Math.trunc(value * f) / f).toFixed(n);
}

export function getPartidoInfo(codPar, parArray) {
  return parArray[Number(codPar)-1];
}

export function getCamaraInfo(codcam, camArray) {
  const camara = camArray[codcam];
  return camara;
}

function noop(strings, ...keys) {
  const lastIndex = strings.length - 1;
  return (
    strings.slice(0, lastIndex).reduce((p, s, i) => p + s + keys[i], "") +
    strings[lastIndex]
  );
}
const html = noop;

export function getLogo(codpar, lang, convocatoria) {
  let cod = codpar && codpar.padStart(4, "0");
  if (codpar === codigos.otros || codpar === codigos.empate) {
    cod = cod + "_" + lang;
  }
  if (convocatoria === "ant") {
    cod = "ANT/" + cod;
  }
  return cod;
}

export function tooltipPartidoYDato(
  ambito,
  colpar,
  nompar,
  datoNum,
  datoTipo,
  datoNumAnt,
  datoTipoAnt,
  inverseFilaDos,
  inverseFilaTres,
  codpar
) {
  return html`
    <div
      class="boxShadow js-echarts-tooltip"
      style="
        min-width: 100px;
        background: white;
        padding: 12px;
        text-align: left;
        line-height: 1.2;
        white-space: normal;
        border-radius: 4px;
        color: #333;
        font-family: Lato;
      "
    >
      ${ambito
        ? html`
            <div
              style="
                width: 100%;
                font-size: 16px;
              "
            >
              ${ambito}
            </div>
          `
        : ""}
      ${nompar
        ? html`
            <div
              class="normal"
              style="width:100%;
                    margin-top: 0.4rem;
                    "
            >
              ${colpar
                ? `<div
                style="
                  border: none;
                  border-left-color: ${colpar};
                  display: inline-block;
                  height: 10px;
                  vertical-align: middle;
                  margin-bottom: 2px;
                  border-width: 0 0 0 10px;
                  border-style: solid;
                "
              ></div>
              `
                : ""}
              ${nompar} ${datoTipo === "tendencia" && datoNum ? datoNum : ""}
            </div>
          `
        : ""}
      ${![null, false, undefined].includes(datoNum) &&
      ![null, false, undefined].includes(datoTipo) != null &&
      datoTipo !== "tendencia"
        ? html`
            <div
              class="normal"
              style="
                    width: 100%;
                    margin-top: 0.4rem;
                    text-transform: lowercase;
                  "
            >
              ${inverseFilaDos
                ? `${datoTipo} ${datoNum}`
                : `${datoNum} ${datoTipo}`}
            </div>
          `
        : ""}
      ${datoNumAnt != null && datoTipoAnt != null
        ? html`
            <div
              class="normal"
              style="
                    width: 100%;
                    margin-top: 0.4rem;
        "
            >
              ${inverseFilaTres
                ? `${datoTipoAnt} ${datoNumAnt}`
                : `${datoNumAnt} ${datoTipoAnt}`}
            </div>
          `
        : ""}
      ${codpar
        ? html`
            <div style="display: flex; margin-top: 10px;">
              <img
                style="
                    height: 44px;
                    margin: 0 auto;
                        "
                src="/assets/img/logo/${codpar}.png"
              />
            </div>
          `
        : ""}
    </div>
  `;
}

export function getAmbitosFromLevel(level, nomen) {
  return nomen.filter(x => x.l === level);
}

export const isDark = color => {
  const darkness =
    1 - (0.299 * color.r + 0.587 * color.g + 0.114 * color.b) / 255;
  return darkness > 0.4;
};

export const hexToRgb = hex => {
  var bigint = parseInt(hex, 16);
  var r = (bigint >> 16) & 255;
  var g = (bigint >> 8) & 255;
  var b = bigint & 255;
  return { r, g, b };
};

export const normalizeHex = hex => {
  if (hex.length === 4) {
    return hex.substr(1).repeat(2);
  }
  return hex.substr(1);
};

export const isHexColor = hex =>
  typeof hex === "string" && hex.length === 6 && !isNaN(parseInt(hex, 16));

export const colorLegible = color => {
  let colorTexto = "#fff";
  const normalizedHex = normalizeHex(color);
  if (isHexColor(normalizedHex) && !isDark(hexToRgb(normalizedHex))) {
    colorTexto = "#000";
  }
  return colorTexto;
};
